import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
@Component({
  selector: 'app-common-message',
  templateUrl: './common-message.component.html',
  styleUrls: ['./common-message.component.css']
})
export class CommonMessageComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<CommonMessageComponent>,@Inject(MAT_DIALOG_DATA) public data: any,
 private _router: Router) {
   console.log(this.data)
    if(this.data.confirmtype == undefined){
      this.data.confirmtype = true;
    }
   }

  ngOnInit() {
  }
  onNoClick(): void {
    this.data.type = "No"
    this.dialogRef.close(this.data.type);
  }
  onYesClick(): void {
    this.data.type = "Yes";
    this.dialogRef.close(this.data.type);
    //this._router.navigate(["dashboard"])
  }

}
